/* hayakmodule */
define( '../src/hayak/sublayouts/m39-modal/m39-modal',[ 'jquery', 'lib/utils', 'mask', 'spinner', 'parsley' ], function ( $, utils, Mask, Spinner, parsley ) {
	'use strict';

	var Modal = function ( $component ) {

		this.$component = $component;

		return this;
	};

	Modal.prototype.init = function () {

		// set a unique id (safer than doing this inline)
		var uniqueID = utils.uniqueID(),
			_this = this,
			triggerID = uniqueID + '_trigger',
			contentID = uniqueID + '_content',
			closeID = uniqueID + '_close';

		// cache dom els
		this.$content = this.$component.find( '[ data-content ]' );
		this.$close = this.$component.find( '[ data-close ]' );
		this.$body = $( 'body' );
		this.$modalContent = this.$component.find( '.m39-modal__content' );
		this.$overlay = $('.m39-modal__overlay')

		if ( this.$content.data( 'content' ) === true ) {

			this.$trigger = this.$component.find( '[ data-trigger ]' );

		} else {

			// account selector
			this.$trigger = $( '[ data-accountselector="' + this.$content.data( 'content' ) + '" ]' );

			// other
			if ( this.$trigger[ 0 ] === undefined ) {
				this.$trigger = $( '[ data-modal-trigger="' + this.$content.data( 'content' ) + '" ]' );
			}

		}
   



		// make sure trigger is not triggred when hitting enter in a form
		if ( this.$trigger.is( 'button' ) ) {

			this.$trigger.attr( 'type', 'button' );
		}

		// add dynamic ids and props for aria tagging
		this.$trigger.attr( 'id', triggerID ).attr( 'aria-controls', contentID );
		this.$content.attr( 'id', uniqueID + '_content' ).attr( 'aria-labelledby', triggerID );
		this.$close.attr( 'id', closeID ).attr( 'aria-controls', contentID );

		// classnames
		this.openContentClassname = 'm39-modal__container--active';

		// bind events
		this.$trigger.on( 'click', function(e){
			var __this = this;
			if (_this.$component.hasClass('m39-modal--form_binded')) {
				var e_count = 0;

				$(_this.$component.attr('target-form')).parsley().validate();
				$(_this.$component.attr('target-form')).find('.form-field__input').each(function(){
					if (!$(this).parsley().isValid()) {
						e_count++;
					};
				})
				if (e_count == 0) {
					//console.log('asdasdadasd')
					_this.show(e)
				}
			} else {
				_this.show(e)
			}
		} );
		this.$close.on( 'click', $.proxy( this.hide, this ) );
		$('.m39-m12-no').on('click', $.proxy( this.hide, this ));
		this.$body.on( 'focusin', $.proxy( this.checkModalFocus, this ) );

		jQuery('.m36-videoplayer--image').off('click.video').on('click.video',function() {
			var title = jQuery(this).closest('.m36-videoplayer--variant').attr('data-title'),
				content = jQuery(this).closest('.m36-videoplayer--variant').attr('data-iframe');

			jQuery('.m39-modal--video').find('.m39-modal__title').html(title);
			jQuery('.m39-modal--video').find('.m39-modal__content').html(content);
			jQuery('.m39-modal--video').find('.m39-modal__trigger').trigger('click');

			if(jQuery(this).closest('.m36-videoplayer--variant').hasClass('m36-videoplayer--modal')){
				var uniqueID = utils.uniqueID(),
					thisContain = jQuery(this).closest('.m36-videoplayer--variant'),
					viModal = jQuery('.m39-modal--video .m39-modal__content').find('video');
					thisContain.data('vid', uniqueID);
					thisContain.attr('data-vid', uniqueID);
					viModal.attr('id',uniqueID)
			}
			/*if(jQuery(this).closest('.m36-videoplayer--variant').hasClass('m36-videoplayer--modal')){
				var modalVidContent = jQuery(this).closest('.m36-videoplayer--variant').find('.m36-videoplayer--modal-content').html();
					jQuery('.m39-modal--video').find('.m39-modal__content').html(modalVidContent);
			}*/

		});

		jQuery('.m36-videoplayer--tutorial-link').off('click.video').on('click.video',function() {
			var title = jQuery(this).closest('.m36-videoplayer--variant').attr('data-title'),
				content = jQuery(this).closest('.m36-videoplayer--variant').attr('data-iframe');

			jQuery('.m39-modal--video').find('.m39-modal__title').html(title);
			jQuery('.m39-modal--video').find('.m39-modal__content').html(content);
			jQuery('.m39-modal--video').find('.m39-modal__trigger').trigger('click');
		});

	};

	Modal.prototype.checkModalFocus = function ( e ) {

		var _this = this,
			isMpActive = $('.datepicker').hasClass('active');

		window.setTimeout( function () {

			if (_this.modalOpened && _this.$content.find( ':focus' ).length === 0 && !isMpActive && !_this.$component.hasClass('m39-modal--nofocus')) {

				e.stopPropagation();
				_this.$close.click();
			}

		}, 1 );

	};

	Modal.prototype.show = function ( e ) {

		var _this = this;

        var spinner = new Spinner( _this.$content  );
        spinner.load();

		e.preventDefault();

        setTimeout(function(){
        	//console.log('here')
            Mask.show();
            _this.$body.addClass( 'unscrollable' );
            _this.$body.css({position:'static'})

            _this.setContentBelowHeader();
            $( window ).on( 'resize orientationchange', $.proxy( _this.setContentBelowHeader, _this ) );

            _this.$content.attr( 'aria-expanded', true );
            _this.$content.addClass( _this.openContentClassname );

            window.setTimeout( function () {
                
                spinner.unload();
                //_this.$close.focus();
                $('body').trigger('modal_opened', _this);
                 
            }, 501 ); // let the css visibility transition finish... otherwise .focus() will fail. ugly but necessary.

            _this.modalOpened = true;
            $(_this.$overlay).css('display', 'block')

        }, 50);
    };

	Modal.prototype.setContentBelowHeader = function () {

		this.headerHeight = this.$component.find( '.m39-modal__header' ).innerHeight() + 'px';
		this.$modalContent.css( 'top', this.headerHeight );
	};

	Modal.prototype.hide = function ( e ) {

		e.preventDefault();

        $('body').trigger('modal_closed', this);

        Mask.hide();


        if(this.$component.hasClass('m39-modal--video')){
        		this.$modalContent.empty()
        }


		this.$body.removeClass( 'unscrollable' );
		this.$body.css({position:''})
		this.$content.attr( 'aria-expanded', false );
		this.$content.removeClass( this.openContentClassname );
		this.modalOpened = false;
		this.$trigger.focus();
		$(this.$overlay).css('display', 'none')
	};

	Modal.prototype.autoShow = function(ID) {
        var _this = this;

       setTimeout(function () {
                $('#'+ID).trigger('click')
            }, 3000)
        
    };

	return Modal;

} );

